/* Aeko: on-brand form validation (replaces the browser's grey pop-up bubbles) */
(function () {
  var MESSAGES = {
    email: 'Please enter a valid email address.',
    required: 'Please fill in this field.',
    password: 'Please enter your password.'
  };
  function messageFor(input) {
    if (input.validity.valueMissing) {
      if (input.type === 'email') return 'Please enter your email address.';
      if (input.type === 'password') return MESSAGES.password;
      return MESSAGES.required;
    }
    if (input.validity.typeMismatch && input.type === 'email') return MESSAGES.email;
    if (input.validity.tooShort) return 'Please use at least ' + input.minLength + ' characters.';
    return input.validationMessage || MESSAGES.required;
  }
  function anchorFor(input) {
    return input.closest('.inline-form, .aeko-pop__row, .field, .stack-form > div, label') || input;
  }
  function clear(input) {
    input.removeAttribute('aria-invalid');
    var id = input.getAttribute('data-err');
    if (id) { var el = document.getElementById(id); if (el) el.remove(); input.removeAttribute('data-err'); }
    var a = anchorFor(input); if (a && a.classList) a.classList.remove('is-invalid');
  }
  function show(input) {
    clear(input);
    var id = 'err-' + Math.random().toString(36).slice(2, 8);
    var p = document.createElement('p');
    p.className = 'field-error';
    p.id = id;
    p.setAttribute('role', 'alert');
    p.textContent = messageFor(input);
    var a = anchorFor(input);
    a.insertAdjacentElement('afterend', p);
    if (a.classList) a.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', id);
    input.setAttribute('data-err', id);
  }
  function init(form) {
    if (form.dataset.aekoValidate) return;
    form.dataset.aekoValidate = '1';
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      var first = null;
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.willValidate || el.type === 'hidden') return;
        if (!el.checkValidity()) { show(el); if (!first) first = el; } else { clear(el); }
      });
      if (first) { e.preventDefault(); e.stopImmediatePropagation(); first.focus(); }
    }, true);
    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.checkValidity()) clear(e.target);
    });
  }
  function run() { document.querySelectorAll('form').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
